import React, { Component, Fragment, useEffect, useState } from 'react';
import PieChart from './Graph/PieChart'
import PercentHistogram from './Graph/PercentHistogram'
import './style.css';
import { Layout, Menu, Card, Row, Col, Divider, Table, Input, Spin, Button, DatePicker, Space, message,notification, Modal, Select, Upload, Dropdown, Tabs } from 'antd';
import { BarChartOutlined,  DoubleRightOutlined , ExclamationCircleFilled } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { UploadOutlined, SyncOutlined, DownOutlined, SearchOutlined, PlusOutlined,WechatOutlined,CommentOutlined  } from '@ant-design/icons';
import { Link, useHistory, Redirect } from "react-router-dom";
import { getOverview, getGraphData, getClerkDistributionList, getStatusTable, getFileRefrence, viewDashboardSelector, clearState, uploadPdfAsyn, fetchAllUserData, clearRoomUserData } from './ClerkDashboardSlice';
import { gviewDashboardSelector, getCollaborationNotification, updateNotification} from '../../../CHDPanel/Dashboard/component/ChdDashboardSlice';
import moment from 'moment';
import ClerkDistributionList from './ClerkDistributionList';
import IncomingStatus from './IncomingStatus';
import DispatchedStatus from './DispatchedStatus';
import InProgressStatus from './InProgressStatus';
import FiledStatus from './FiledStatus';
import FileReferenceStatus from './FileReferenceStatus';
import ability from '../../../../config/ability';
import {authSelector} from '../../../Auth/authSlice';
const { Dragger } = Upload;
const { Header, Content, Footer, Sider } = Layout;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const style = { padding: '8px 0' };
const { Search } = Input;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { confirm } = Modal;

export default function Dashboard() {

  const { Option } = Select;
  const dispatch = useDispatch();
  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [fileList, setfileList] = React.useState([]);
  const [pdfUrl, setpdfUrl] = React.useState("");
  const [graphValue, setgraphValue] = React.useState([]);
  const [distributionlistData, setdistributionlistData] = useState([]);
  const [graphType, setgraphType] = useState('day');
  const [page, setPage] = useState(1);
  const [currentTab, setcurrentTab] = useState('inprogress');
  const [search, setSearch] = useState('');

  const { user } = useSelector(
    authSelector
  );



  // console.log(user)

  let history = useHistory()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const { isNotification, NotificationData} = useSelector(
    gviewDashboardSelector
  );
  const { isFetching, isSuccess, isGraphSuccess, isAllUserDataSuccess, isDistListSuccess, AllUserData, isFileRefSuccess, fileRefrenceData, isError, listCount, isTableDataSuccess, statusTabledata, errorMessage, Overview, graphData, DistributionListData } = useSelector(
    viewDashboardSelector
  );

  useEffect(() => {
    notification.destroy();
    setToast(false);
    setLoading(true);
    dispatch(clearState());
    dispatch(clearRoomUserData());
    dispatch(getOverview());
    setTimeout(() => {
      dispatch(getCollaborationNotification(user.userType));
      dispatch(getGraphData(graphType));
    }, 1000);
    setTimeout(() => {
      dispatch(getStatusTable('isStatus=' + currentTab + '&page=' + page + '&limit=10'));
    }, 2000);

  }, []);

  // setTimeout(()=>{
  //   dispatch(getCollaborationNotification(user.userType));

  // },1000)
  const [launched,setLaunch]=useState(false)
  useEffect(() => {

    if (isError) {
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);
      dispatch(clearState());
      dispatch(clearRoomUserData());
    }
    if (isSuccess) {
      setLoading(false);
    }

    if (!launched && isNotification && NotificationData.data && NotificationData.data.length > 0 && NotificationData.data[0].receiver==user.username) {
      notification.destroy();
      const readCol = (value,args) => {
        notification.destroy();
        dispatch(updateNotification({"roomId":value}, user.userType))
        dispatch(getCollaborationNotification(user.userType));
    
        history.push({
          pathname: '/new-document',
          state: { roomId: value}
      });
     
      };
    
      setLoading(false);
    
    // if(NotificationData && NotificationData.length >0){
      for (let i = 0; i < 1; i++) {
        const btn = (
          <Space>
            <Button
              type="primary"
              onClick={() => {
                readCol(NotificationData.data[i].roomId,args);
              }}
              size="small"
            >
              <CommentOutlined /> View
            </Button>
          </Space>
        );
    
        const args = {
          btn,
          message: "New Collaboration Message",
          description: `${NotificationData.data[i].message}. TITLE: ${NotificationData.data[i].docName}`,
          icon: (
            <WechatOutlined
              style={{
                color: '#108ee9',
              }}
            />
          ),
          duration: 0,
        };
    
        notification.open(args);
        setLaunch(true)
      }
    // }
    }
    if (isGraphSuccess) {
      setgraphValue(graphData);
    }
    if (isDistListSuccess) {
      setdistributionlistData(DistributionListData);
    }

    // if (isAllUserDataSuccess) {
    //   
    //   history.push({
    //     pathname: '/new-document',
    //     state: { roomId: AllUserData.roomId }
    //   });
    //   dispatch(clearRoomUserData());
    // }

  }, [isError, listCount, isSuccess, isTableDataSuccess, isAllUserDataSuccess, isFileRefSuccess, isDistListSuccess, setLoading, AllUserData, Overview, graphData, DistributionListData, fileRefrenceData, statusTabledata]);



  const saveImage = () => {

  }
  const singleuploadprops = {
    name: 'file',
    action: saveImage(),
    headers: {
      authorization: 'authorization-text',
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleUploadChange = (info) => {

    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      setLoading(false);
      return;
    }
    // console.log(info.file.originFileObj)
    // if (info.file.status === "uploading" || info.file.status === "done") {

    //   setfileList(info.fileList);

    //   // getBase64(info.file.originFileObj, (imgUrl) => {

    //   // });
    //   return;
    // }
  };

  const uploadPdfDoc = (file) => {

    const data = new FormData();
    data.append('pdfFile', file.file);
    dispatch(uploadPdfAsyn(data)).then((res) => {
      setLoading(false);
      if (res.code == 200) {
        message.success(res.message);
        setIsModalVisible(false);
        history.push({
          pathname: '/add-document',
          // search: '?query=abc',
          state: { documentId: res.data.documentId, processId: res.data.processId, createdAt: res.data.createdAt }
        });
      }
      else if (res.code == 201) {
        message.success(res.message);
      }
      else {
        message.error(res.message);
      }

    });
  }


  const callback = (key) => {
    localStorage.setItem('defaultClerkTab', key);
    if (key === 'incoming' || key === 'dispatched' || key === 'inprogress' || key === 'filed') {
      setcurrentTab('');
      setcurrentTab(key);
      let data = `isStatus=${key}&page=${page}&limit=10`;
      dispatch(getStatusTable(data));
    }
    else if (key === 'File Reference') {
      dispatch(getFileRefrence('page=1&limit=10'));
    }
    else if (key === 'Distribution List') {
      dispatch(getClerkDistributionList());
    }
  }


  const handleGraphValue = (e) => {
    dispatch(getGraphData(e));
    setgraphType('');
    setgraphType(e);
  }


  const getRoomForEditor = () => {
    dispatch(fetchAllUserData()).then((res) => {
      // console.log(res)
      if (res && res.payload && res.payload.data) {
        history.push({
          pathname: '/new-document',
          state: { roomId: res.payload.data.roomId }
        });
      }
      dispatch(clearRoomUserData());
    })
  }


  // Yusuf Confirmation prompt code for New Document


const showConfirm = () => {
  confirm({
    title: 'Do you want to create a collaboration document?',
    icon: <ExclamationCircleFilled />,
    content: 'Clicking OK would automatically log document and all changes in real-time.',
    onOk() {
      getRoomForEditor();
      console.log('OK');
    },
    onCancel() {
      console.log('Cancel');
    },
  });
};

//end of

  let [showAnal, setshowAnal]= useState(false);
  let [ displayAnal, setdisplayAnal]= useState("Show Analytics");
  const myToggle = () =>{
    if(showAnal==false){
      setshowAnal(true);
      setdisplayAnal("Hide Analytics");
    }

    if(showAnal==true){
      setshowAnal(false);
      setdisplayAnal("Show Analytics");
    }

  }



  return (
    <>

      <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
      {isToast &&
        <Toaster
          toastOptions={{
            className: '',
            style: {
              border: '1px solid #713200',
              padding: '16px',
              color: '#713200',
              marginTop: 50
            },
          }}
        >
          {(t) => (
            <ToastBar toast={t}>
              {({ icon, message }) => (
                <>
                  {icon}
                  {message}
                  {t.type !== 'loading' && (
                    <button onClick={() => toast.dismiss(t.id)}>X</button>
                  )}
                </>
              )}
            </ToastBar>
          )}
        </Toaster>
      }


      <Content>
      <h1 style={{ color: '#ffffff',  fontWeight: 700, fontSize: '30px', width: 'calc(100%)', display: 'inline-block' }}>
          <span style={{"text-transform":"uppercase","display":"flex","placeContent":"center"}}>{user.username}</span></h1>

          <Row>
        <Col span={-8}>
       {/* <Button type="primary" onClick={myToggle} icon={<BarChartOutlined />} size='large'>
        {displayAnal}
      </Button> */}
       </Col>
    </Row>
        <Row>
       {showAnal==true &&

<Col span={12} style={{ backgroundColor: '#ffffff', borderRadius: '5px', border: "1px solid #e3e5ee" }}>
<div style={{ padding: '20px' }} className="clerk-analitics-chart">
  <p className="transformyaxis" >Total Process</p>
  <div className="clerk-analitic-title-dropdown">
    <h2>Analytics
    </h2>
    <Select onChange={handleGraphValue} defaultValue="Current Day" size="small" className="ant-dropdown-link ant-select-customize-input">
      <Option value="day">Current Day</Option>
      <Option value="week">Current Week</Option>
      <Option value="month">Current Month</Option>
    </Select>
  </div>
  <PercentHistogram datainGraph={graphValue} defaultGraphType={graphType} />
  <p style={{ color: "#8c8ea2", textAlign: 'center', marginBottom: '0px', position: 'absolute', left: '45%', bottom: '15px' }}>Progress Status</p>
</div>
</Col>

       }
        {showAnal==true &&

<Col span={12} style={{ paddingLeft: '25px' }}>
<div style={{ padding: '20px', border: "1px solid #e3e5ee", borderRadius: '5px', backgroundColor: '#ffffff' }}>
  <h2 style={{ fontWeight: 700, color: '#172b4d' }}>Overview</h2>
  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ marginBottom: '30px', marginTop: '20px' }}>
    <Col className="gutter-row" span={12}>
      <div style={style, { background: "#2F6CDE", padding: 10, paddingLeft: 15, borderRadius: 5 }}>
        <Row >
          <Col span="20" style={{ color: "#FFFFFF", fontSize: 25, fontWeight: 'bold' }}>
            {Overview && Overview.incoming ? Overview.incoming : 0}
          </Col>
          <Col span="4" className="dashboard-overview-icon">
            <img src="/newicons/barChart.svg" alt="image" style={{ height: 20, margin: '10px' }} />
          </Col>
        </Row>
        <Row >
          <Col span="24" style={{ color: "#FFFFFF", fontSize: 16 }}>
            Incoming
          </Col>
        </Row>
      </div>
    </Col>
    <Col className="gutter-row" span={12}>
      <div style={style, { background: "#BD34EB", padding: 10, paddingLeft: 15, borderRadius: 5 }}>
        <Row>
          <Col span="20" style={{ color: "#FFFFFF", fontSize: 25, fontWeight: 'bold' }}>
            {Overview && Overview.dispatched ? Overview.dispatched : 0}
          </Col>
          <Col span="4" className="dashboard-overview-icon">
            {/* <IoIosGitBranch/> */}
            <img src="/newicons/checkCircle.svg" alt="image" style={{ height: 20, margin: '10px' }} />
          </Col>
        </Row>
        <Row>
          <Col span="24" style={{ color: "#FFFFFF", fontSize: 16 }}>
            Dispatched
          </Col>
        </Row>
      </div>
    </Col>

  </Row>
  {/* <Divider /> */}
  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
    <Col className="gutter-row" span={12}>
      <div style={style, { background: "#26D2B1", padding: 10, paddingLeft: 15, borderRadius: 5 }}>
        <Row>
          <Col span="20" style={{ color: "#FFFFFF", fontSize: 25, fontWeight: 'bold' }}>
            {Overview && Overview.inprogress ? Overview.inprogress : 0}
          </Col>
          <Col span="4" className="dashboard-overview-icon">
            <img src="/newicons/package.svg" alt="image" style={{ height: 20, margin: '10px' }} />
          </Col>
        </Row>
        <Row>
          <Col span="24" style={{ color: "#FFFFFF", fontSize: 16 }}>
            In Progress
          </Col>
        </Row>
      </div>
    </Col>
    <Col className="gutter-row" span={12}>
      <div style={style, { background: "#E84C32", padding: 10, paddingLeft: 15, borderRadius: 5 }}>
        <Row>
          <Col span="20" style={{ color: "#FFFFFF", fontSize: 25, fontWeight: 'bold' }}>
            {Overview && Overview.filed ? Overview.filed : 0}
          </Col>
          <Col span="4" className="dashboard-overview-icon">
            <img src="/newicons/calculateBlack.svg" alt="image" style={{ height: 20, margin: '10px' }} />
          </Col>
        </Row>
        <Row>
          <Col span="24" style={{ color: "#FFFFFF", fontSize: 16 }}>
            Treated
          </Col>
        </Row>
      </div>
    </Col>
  </Row>
</div>
</Col>


        }
        </Row>


        {/* Tabs section ... */}
        <Row style={{ marginTop: 20 }}>
          <Col span={24} style={{ border: "1px solid #e3e5ee", borderRadius: '5px', backgroundColor: '#ffffff' }} className="clerk-dashboard-tab-sec clerk-dashboard-new-tab-style">
            {/* <Row type="flex" >
              <Col span={24} style={{ textAlign: 'right' }}>
                
              </Col>
            </Row> */}

            <Space className="clerk-dashboard-btns-grp">


            {<div  className='createP'>
              <span style={{paddingLeft:'10px'}}>  Create Process
              <Button type="default"  icon={<DoubleRightOutlined />} size='small'>
      
      </Button>
              </span>
                </div>}

              {ability.can('clerkPermission', 'addDocuments') && <Button className={'tblbtnClass'} onClick={showModal} type={'primary'} size={'middle'}>+ Upload Document</Button>}
              <Button className={'tblbtnClass'} onClick={showConfirm} type={'danger'} size={'middle'}>+ New Document</Button>
            </Space>

            <Tabs  defaultActiveKey="1" style={{height:'400px'}}>

          

{/*          
           <TabPane ref={tabRef}   tab= {`Incoming - ${Overview && Overview.incoming ? Overview.incoming : 0}`} key="incoming">
                <IncomingStatus />

              </TabPane> */}
       <div style={{width:'700px', padding:'10px'}}><h2>Welcome to NAF Paperless Automation System.
         Click on the "+ Upload Document" button on the right to start the proccess of sending
         your scanned pdf/pdf file document to someone. 
         <br />
         
         To make draft or collaboration document, click on the "+ New Document" button. </h2></div>
           
          
              {/* <TabPane tab={`Dispatched - ${  Overview && Overview.dispatched ? Overview.dispatched : 0}`} key="dispatched">
                <DispatchedStatus />

              </TabPane> */}
              {/* <TabPane tab={`Create Process - >>>`}>
        

              </TabPane> */}
              {/* <TabPane tab={` Treated - ${Overview && Overview.filed ? Overview.filed : 0}`} key="filed">
                <FiledStatus />
              </TabPane> */}

              {/* <TabPane tab="File Reference" key="File Reference">
                <FileReferenceStatus />

              </TabPane> */}
            </Tabs>


            {/* upload butn */}

            {/* <Button onClick={showModal} style={{ position: 'absolute', top: '18px', right: '35px',paddingTop: '2px' }} type={'primary'}>+ New Document</Button> */}

            <Modal centered width={700} okButtonProps={{ style: { display: 'none' } }} title="" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
              <div style={{ padding: 20 }}>
                <h2 >Upload Document</h2>
                <Dragger style={{ padding: 40 }} accept={'.pdf'}
                  listType="picture-card"
                  // className="avatar-uploader"
                  showUploadList={false}
                  customRequest={uploadPdfDoc}
                  onChange={handleUploadChange}
                  onDrop={(e) => {
                    const isPdf = e.dataTransfer.files[0].type === 'application/pdf';
                    if (!isPdf) {
                      message.error('You can only upload PDF file!');
                    }
                    // const isLt2M = file.size / 1024 / 1024 < 2;
                    // if (!isLt2M) {
                    //   message.error('Image must smaller than 2MB!');
                    // }

                    console.log('Dropped error', e.dataTransfer.files[0].type);
                    console.log('Dropped files', e.dataTransfer.files);
                  }}
                >
                  <p className="ant-upload-drag-icon">
                    <UploadOutlined style={{ color: 'black' }} />
                  </p>
                  <p className="ant-upload-text">Drag & Drop (or) Browse file</p>
                  <p className="ant-upload-hint">

                  </p>
                </Dragger>
              </div>
            </Modal>



          </Col>
        </Row>
        <Row style={{ marginTop: 50, marginBottom: 50 }}><Col span={24}></Col></Row>

      </Content>
    </>
  );
}
